import { backgroundActionResultRunner, cancelBackgroundActionRunner } from "./operationRunners.js";
class BackgroundActionHandle {
  constructor(connection, action, id) {
    this.connection = connection;
    this.action = action;
    this.id = id;
  }
  /** Wait for this background action to complete and return the result. */
  async result(options) {
    return (await backgroundActionResultRunner(this.connection, this.id, this.action, options)).result;
  }
  /** Cancel this background action by id. */
  async cancel() {
    await cancelBackgroundActionRunner(this.connection, this.id);
  }
}
export {
  BackgroundActionHandle
};
//# sourceMappingURL=BackgroundActionHandle.js.map
